import { i18n } from '../services/i18n';

export const translate = (key: string) => {
    const value = i18n.t(key);

    return [key, '', ' '].includes(value) ? '' : value;
};
